import { ClearSearchComponent } from './atlas-clear-search/atlas-clear-search.component';
import { DefineNewLocationDialogComponent } from './atlas-define-new-location-dialog/atlas-define-new-location-dialog.component';
import { DefineNewLocationFormComponent } from './atlas-define-new-location-form/atlas-define-new-location-form.component';
import { DefineNewLocationComponent } from './atlas-define-new-location/atlas-define-new-location.component';
import { DropPinComponent } from './atlas-drop-pin/atlas-drop-pin.component';
import { FindMyLocationComponent } from './atlas-find-my-loaction/atlas-find-my-location.component';
import { GazetteerComponent } from './atlas-gazetteer.component';

export const components = [
  GazetteerComponent,
  FindMyLocationComponent,
  DropPinComponent,
  DefineNewLocationComponent,
  DefineNewLocationDialogComponent,
  DefineNewLocationFormComponent,
  ClearSearchComponent
];
